import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";
import store from "./store";
import config from "@/config";
import ViewUI from "view-design";
import KeepRatio from "vue-keep-ratio";

import {
    curlHttp,
    localRead,
    dateStrFormat,
    dateFormat,
    hasPermission,
} from "@/library/utils";
import api from "@/library/api.service";
import "view-design/dist/styles/iview.css";
import "@/assets/style/app.less";
import "default-passive-events";

Vue.use(ViewUI);
Vue.use(KeepRatio);

Vue.prototype.$config = config;
Vue.prototype.curlHttp = curlHttp;
Vue.prototype.dateStrFormat = dateStrFormat;
Vue.prototype.dateFormat = dateFormat;
Vue.prototype.api = api;
Vue.prototype.localRead = localRead;
Vue.prototype.hasPermission = hasPermission;

Vue.config.productionTip = false;

new Vue({
    el: "#app",
    router,
    store,
    render: (h) => h(App),
    mounted() {
        if (localRead("userinfo")) {
            let userInfo = JSON.parse(localRead("userinfo"));
            if (userInfo.user_id) {
                // this.$store.commit("createWsConnect", this);
                // this.$store.commit("autoWsPING");
            }
        } else {
            console.log("未登录");
        }
    },
});
window.addEventListener("touchmove", (e) => e.preventDefault());
